const CACHE_NAME = "vionix-event-images-v1";

/**
 * Fetches an image from Cache API first.
 * If not cached, fetches from Firebase Storage, caches it, returns blob URL.
 */
export const getCachedImageUrl = async (eventId, remoteUrl) => {
    if (!remoteUrl) return "/bg/smm.webp";
    if (!("caches" in window)) return remoteUrl;

    try {
        const cache = await caches.open(CACHE_NAME);
        const cached = await cache.match(remoteUrl);

        if (cached) {
            const blob = await cached.blob();
            return URL.createObjectURL(blob);
        }

        const response = await fetch(remoteUrl, { mode: "cors" });
        if (response.ok) {
            await cache.put(remoteUrl, response.clone());
            const blob = await response.blob();
            return URL.createObjectURL(blob);
        }
    } catch (e) {
        console.warn("[ImageCache] Failed:", e);
    }
    return remoteUrl;
};

export const getOptimizedEventImage = (eventId, remoteUrl) => {
    return remoteUrl || "/bg/smm.webp";
};
